
import Vue from 'vue';
import FilePreview from './FilePreview.vue';
import { FileModel } from '../../models/FileModel';

export default Vue.extend({
  components: {
    FilePreview,
  },
  props: {
    files: {
      type: Array as Vue.PropType<FileModel[]>,
      default: (): any => [],
    },
  },
});
